import Util from "@/helper/Utility.js";

export default {
    inject: ["DeliveryStore"],
    computed: {
        tier: function() {
            if (this.DeliveryStore.state.delivery) {
                return this.DeliveryStore.state.delivery.category;
            } else {
                return null;
            }
        },
        delivery: function () {
            if (this.DeliveryStore.state.delivery) {
                return this.DeliveryStore.state.delivery;
            } else {
                return null;
            }
        },
        isFromDeliveryMethod: function () {
            if (this.DeliveryStore.state.isFromDeliveryMethod) {
                return this.DeliveryStore.state.isFromDeliveryMethod;
            } else {
                return false;
            }
        },
    },
    watch: {
        'DeliveryStore.state.isInitialDelivery': function () {
            let isReady = this.DeliveryStore.state.isInitialDelivery;

            Util.log('delivery', this.delivery);

            if (Util.isFunction(this.onDeliveryUpdate)) {
                this.onDeliveryUpdate(isReady)
            }
        },
    },
    created: function () {

    },
    methods: {
        deliveryInit: function() {
            this.DeliveryStore.methods.init();
        },
        getDelivery: function() {
            this.DeliveryStore.methods.getDelivery();
        },
        getDeliveryFromCache: function() {
            this.DeliveryStore.methods.getDeliveryFromCache();
        },
        updateDelivery: function(delivery) {
            this.DeliveryStore.methods.updateDelivery(delivery);
        },
        removeDelivery: function() {
            this.DeliveryStore.methods.removeDelivery();
        },
        updateIsFromDeliveryMethod: function(isFromDeliveryMethod) {
            this.DeliveryStore.methods.updateIsFromDeliveryMethod(isFromDeliveryMethod);
        }
    },
}
